import {ImageService} from "nuxt-spoferan/src/services/ImageService";

export default ({$config}, inject) => {
    inject('image', new ImageService($config.storageUrl, $config.storageBucket));
}